import tabsMenuHandler from '../components/tabsMenuHandler.js'

let tabsOfferHandler = () => {
    let offers = document.querySelectorAll('.ranking__wrap')

    for (let i = 0; i < offers.length; i++) {
        tabsMenuHandler(
            offers[i],
            '.tabs-ranking__title-js',
            '.tabs-ranking__accordion-title',
            '.tabs-ranking__accordion-content'
        )
    }
}

export default tabsOfferHandler
